export const DEFAULT_YAML_PATH = 'reliant.yaml';
export const DEFAULT_BRANCH = 'main';
